// extracted by mini-css-extract-plugin
module.exports = {"customTable__content":"Table_customTable__content__96Zi_","customTable":"Table_customTable__Kmhs_"};